var swiper = new Swiper(".washingInstructions", {
  slidesPerView: 4,
  spaceBetween: 20,
  // centeredSlides: true,
  // loop: true,
  // speed: 2000,
  // autoplay: {
  //   delay: 1,
  //   disableOnInteraction: false,
  // },
  breakpoints: {
    0: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});
